import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WebConfiguration} from './web-configuration';

@Injectable({
  providedIn: 'root'
})
export class WebConfigurationService {

  public configuration: WebConfiguration;

  constructor(private httpClient: HttpClient) {
  }

  private downloadConfigurations(configurationFile: string) {
    return this.httpClient
      .get<WebConfiguration>(configurationFile)
      .toPromise();
  }

  public loadConfiguration() {
    return this.downloadConfigurations('assets/configurations/web.configuration.json')
      .then(webConfiguration => {
        this.configuration = webConfiguration;
      });
  }
}
